import React from "react";
import { Modal, Button, Typography } from "@plum-xoxo/admin-dsm";

const PhysicalCardsRequestModal = ({ isOpen, onClose }) => {
  const handleCancel = () => {
    onClose();
  };

  const handleRequestNow = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      disableCloseButton={false}
      style={{ width: "500px" }}
    >
      <Typography.H2 color="dark" shade="c300" className="mb-16">
        Contact Us!
      </Typography.H2>

      <Typography color="dark" shade="c200" className="mb-32">
        Contact us at cs@xoxoday.com and we will get in touch with you to understand your requirements and help you send physical gifts.
      </Typography>

      <Typography component="div" className="d-flex justify-content-end w-100 mt-24">
        <Button
          variant="fill"
          onClick={handleRequestNow}
        >
          Got it 
        </Button>
      </Typography>
    </Modal>
  );
};

export default PhysicalCardsRequestModal;
